<template>
  <div class="p-6 bg-gray-600 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-sm">
      <img src="/images/logo.png" class="h-32 mx-auto" alt="Casa Auto">
      <form class="mt-6 overflow-hidden" @submit.prevent="submit">
        <div class="mt-12">
          <text-input v-model="form.email" :data-error="error('email')" :label="__('Email')" type="email" autofocus
                      autocapitalize="off"/>
        </div>
        <div class="mt-4">
          <text-input v-model="form.password" :data-error="error('password')" :label="__('Password')" type="password"/>
        </div>
        <div class="mt-4">
          <text-input v-model="form.password_confirmation" :data-error="error('password_confirmation')" :label="__('Confirm password')" type="password"/>
        </div>

        <div class="mt-12 flex justify-center">
          <loading-button :loading="sending" class="uppercase px-12 py-4 bg-coral-400 text-white text-2xl font-light"
                          type="submit">
            {{ __("Reset password") }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    LoadingButton,
    Logo,
    TextInput,
  },
  props: {
    email: String,
    token: String,
    errors: Object,
  },
  data() {
    return {
      sending: false,
      form: {
        email: this.email,
        password: '',
        password_confirmation: '',
        token: this.token,
      },
    }
  },
  mounted() {
    document.title = this.__("Password reset")
  },
  methods: {
    submit() {
      this.sending = true;
      this.$inertia.post(this.route('reset-password.store'), {
        email: this.form.email,
        token: this.form.token,
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
      }).then(() => this.sending = false)
    },
  },
}
</script>
